function setVideoCoverVisible(videoWrap, visible) {
  const cover = videoWrap.querySelector(".ambassador-carousel__video-cover");
  if (cover) {
    cover.classList.toggle("is-hidden", !visible);
  }
}

function pauseAllVideosInCarousel(carousel) {
  carousel.querySelectorAll(".ambassador-carousel__video-wrap video").forEach((video) => {
    video.pause();
    const videoWrap = video.closest(".ambassador-carousel__video-wrap");
    if (videoWrap) {
      setVideoCoverVisible(videoWrap, true);
    }
  });
}

function handleSlideSelect(carousel) {
  pauseAllVideosInCarousel(carousel);

  const selectedSlide = carousel.querySelector(".carousel-cell.is-selected");
  if (!selectedSlide) return;

  const videoWrap = selectedSlide.querySelector(".ambassador-carousel__video-wrap");
  if (!videoWrap) return;

  const video = videoWrap.querySelector("video");
  const playBtn = videoWrap.querySelector(".ambassador-carousel__play-btn");

  if (!video) return;

  if (videoWrap.dataset.autoplay === "true") {
    video.muted = true;
    video.play();
  } else if (playBtn) {
    playBtn.hidden = false;
  }
}

function initAmbassadorCarouselVideos() {
  document.querySelectorAll(".ambassador-carousel__video-wrap").forEach((wrap) => {
    const video = wrap.querySelector("video");
    if (!video) return;

    if (!wrap.dataset.coverListener) {
      wrap.dataset.coverListener = "true";
      video.addEventListener("play", () => { setVideoCoverVisible(wrap, false); });
      video.addEventListener("pause", () => { setVideoCoverVisible(wrap, true); });
      video.addEventListener("ended", () => { setVideoCoverVisible(wrap, true); });
    }
  });

  document.querySelectorAll(".ambassador-carousel__video-wrap[data-autoplay='false']").forEach((wrap) => {
    if (wrap.dataset.initialized) return;
    wrap.dataset.initialized = "true";

    const video = wrap.querySelector("video");
    const playBtn = wrap.querySelector(".ambassador-carousel__play-btn");
    if (!video || !playBtn) return;

    video.addEventListener("play", () => { playBtn.hidden = true; });
    video.addEventListener("pause", () => { playBtn.hidden = false; });
    video.addEventListener("ended", () => { playBtn.hidden = false; });

    wrap.addEventListener("click", (e) => {
      const carousel = wrap.closest(".ambassador-carousel");
      if (carousel && carousel.dataset.dragHappened === "true") {
        carousel.dataset.dragHappened = "";
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) {
        video.muted = false;
        video.play();
        playBtn.hidden = true;
      } else {
        video.pause();
        playBtn.hidden = false;
      }
    });
  });

  document.querySelectorAll(".ambassador-carousel").forEach((carousel) => {
    if (carousel.dataset.slideListener) return;
    carousel.dataset.slideListener = "true";

    const attachSelectListener = () => {
      const flkty = window.Flickity && window.Flickity.data(carousel);
      if (flkty) {
        flkty.on("select", () => handleSlideSelect(carousel));
        flkty.on("dragStart", () => { carousel.dataset.dragHappened = "true"; });
        flkty.on("dragEnd", () => {
          setTimeout(() => { carousel.dataset.dragHappened = ""; }, 100);
        });
        handleSlideSelect(carousel);
        return true;
      }
      return false;
    };

    if (!attachSelectListener()) {
      setTimeout(() => attachSelectListener(), 100);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAmbassadorCarouselVideos);
} else {
  initAmbassadorCarouselVideos();
}
